import { Types } from "../actions/BreakdownEffectActions";

const initialState = {
    breakdownEffects: {},
    isTaskUpdated: false,
};

export const BreakdownEffectReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_BREAKDOWN_EFFECTS:
            return {
                ...state,
                breakdownEffects: action.payload ?? state.breakdownEffects,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
